import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ['Mujeres de 45 a 65 años que notan un aumento de peso abdominal repentino.', 'Mujeres que se despiertan cansadas incluso después de dormir "bien".', 'Profesionales que sienten "niebla mental" y falta de enfoque por la tarde.', 'Quienes buscan un método sostenible que no dependa de pasar hambre.'];
const isNotFor = ['Mujeres menores de 35 años (su perfil hormonal es distinto).', 'Personas que buscan una solución mágica o cirugía en una semana.', 'Personas que no están dispuestas a cambiar el orden de sus comidas.'];
export function Audience() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-3">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-sage/10 rounded-3xl p-8 md:p-10 border border-brand-sage/20" data-id="element-4">
            <h3 className="text-2xl font-bold text-brand-text mb-8 flex items-center gap-3" data-id="element-5">
              <span className="bg-brand-sage text-white p-2 rounded-full" data-id="element-6">
                <CheckCircle2 className="w-6 h-6" data-id="element-7" />
              </span>
              Este programa ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-8">
              {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-9">
                  <CheckCircle2 className="w-6 h-6 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-10" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-11">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-200" data-id="element-12">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 flex items-center gap-3" data-id="element-13">
              <span className="bg-gray-300 text-gray-600 p-2 rounded-full" data-id="element-14">
                <XCircle className="w-6 h-6" data-id="element-15" />
              </span>
              Este programa NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-16">
              {isNotFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-17">
                  <XCircle className="w-6 h-6 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-18" />
                  <span className="text-gray-600 leading-relaxed" data-id="element-19">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}